import { INTERCOM_HELP_CENTER_URL } from './intercomLoadDiagnostics';
const LAUNCHER_SELECTOR = '.intercom-lightweight-app-launcher, .intercom-launcher-frame, .intercom-launcher-badge-frame';
const MESSENGER_SELECTOR = '.intercom-messenger-frame';
const BOOTSTRAP_FRAME_SELECTOR = '#intercom-frame';
const currentVisibility = ()=>document.visibilityState === 'visible' ? 'visible' : 'hidden';
const isVisiblySized = (element)=>{
    const rect = element.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) {
        return false;
    }
    if (typeof element.checkVisibility === 'function') {
        return element.checkVisibility({
            opacityProperty: true,
            visibilityProperty: true
        });
    }
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
};
const hasVisiblySizedMatch = (selector)=>[
        ...document.querySelectorAll(selector)
    ].some(isVisiblySized);
const isMessengerOpen = ()=>hasVisiblySizedMatch(MESSENGER_SELECTOR);
export const makeIntercomSupportClickEnvironment = (param)=>{
    let { logBIEvent, openNewTab, getNowMs } = param;
    const visibilityAtLoad = currentVisibility();
    return {
        probeDom: ()=>({
                messengerOpen: isMessengerOpen(),
                launcherPresent: hasVisiblySizedMatch(LAUNCHER_SELECTOR),
                bootstrapFramePresent: document.querySelector(BOOTSTRAP_FRAME_SELECTOR) != null
            }),
        waitForMessenger: (timeoutMs)=>new Promise((resolve)=>{
                if (isMessengerOpen()) {
                    resolve({
                        opened: true,
                        wentHidden: false
                    });
                    return;
                }
                const observer = new MutationObserver(()=>{
                    if (isMessengerOpen()) {
                        settle({
                            opened: true,
                            wentHidden: false
                        });
                    }
                });
                const onVisibilityChange = ()=>{
                    if (currentVisibility() === 'hidden') {
                        settle({
                            opened: false,
                            wentHidden: true
                        });
                    }
                };
                const timeoutId = setTimeout(()=>settle({
                        opened: isMessengerOpen(),
                        wentHidden: false
                    }), timeoutMs);
                function settle(outcome) {
                    clearTimeout(timeoutId);
                    observer.disconnect();
                    document.removeEventListener('visibilitychange', onVisibilityChange);
                    resolve(outcome);
                }
                observer.observe(document.body, {
                    childList: true,
                    subtree: true
                });
                document.addEventListener('visibilitychange', onVisibilityChange);
            }),
        getVisibility: currentVisibility,
        getVisibilityAtLoad: ()=>visibilityAtLoad,
        getPathname: ()=>window.location.pathname,
        now: getNowMs,
        logBIEvent,
        openFallbackSupport: ()=>void openNewTab(INTERCOM_HELP_CENTER_URL)
    };
};
